import React, { ReactNode, useEffect } from "react";
import { usePrevious } from "react-use";
import { useSetRecoilState } from "recoil";
import { useAccount, useNetwork } from "wagmi";

import { accountAtom, activeAtom, chainIdAtom } from "../../atoms";

const AccountProvider = ({ children }: { children: ReactNode }) => {
  const { address, isConnected } = useAccount();
  const { chain } = useNetwork();
  const chainId = chain?.id;

  const setAccountAtom = useSetRecoilState(accountAtom);
  useEffect(
    () => {
      if (!address) {
        return;
      }
      setAccountAtom(address ?? "");
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME Why isn't `setAccountAtom` in the deps?
    [address]
  );

  const setActiveAtom = useSetRecoilState(activeAtom);
  useEffect(
    () => {
      setActiveAtom(isConnected);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME Why isn't `setActiveAtom` in the deps?
    [isConnected]
  );

  const setChainId = useSetRecoilState(chainIdAtom);
  useEffect(
    () => {
      setChainId(chainId);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME Why isn't `setChainId` in the deps?
    [chainId]
  );

  const prevAccount = usePrevious(address);
  useEffect(() => {
    if (Boolean(prevAccount) && prevAccount !== address) {
      // TODO: Reset account state
    }
  }, [prevAccount, address]);

  const prevChainId = usePrevious(chainId);
  useEffect(() => {
    if (Boolean(prevChainId) && prevChainId !== chainId) {
      // TODO: Reset account state
    }
  }, [prevChainId, chainId]);

  return <>{children}</>;
};

export default AccountProvider;
